import { render, staticRenderFns } from "./ShippingManagement.vue?vue&type=template&id=53eb6ec4&scoped=true&"
import script from "./ShippingManagement.vue?vue&type=script&lang=js&"
export * from "./ShippingManagement.vue?vue&type=script&lang=js&"
import style0 from "./ShippingManagement.vue?vue&type=style&index=0&id=53eb6ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb6ec4",
  null
  
)

export default component.exports